import { useState } from "react";
import { Vector2, Vector3 } from "three";

export type StickerMode = "texture" | "decal";

interface StickerState {
  mode: StickerMode;
  textureData: {
    uvPoint: Vector2 | null;
  };
  decalData: {
    point: Vector3 | null;
    normal: Vector3 | null;
  };
}

export const useStickerMode = () => {
  const [state, setState] = useState<StickerState>({
    mode: "texture",
    textureData: { uvPoint: null },
    decalData: { point: null, normal: null },
  });

  const switchMode = (mode: StickerMode) => {
    setState((prev) => ({ ...prev, mode }));
  };

  const updateTextureData = (uvPoint: Vector2) => {
    setState((prev) => ({
      ...prev,
      textureData: { uvPoint },
    }));
  };

  const updateDecalData = (point: Vector3, normal: Vector3) => {
    setState((prev) => ({
      ...prev,
      decalData: { point, normal },
    }));
  };

  const resetMode = () => {
    setState((prev) => ({
      ...prev,
      textureData: { uvPoint: null },
      decalData: { point: null, normal: null },
    }));
  };

  return {
    mode: state.mode,
    textureData: state.textureData,
    decalData: state.decalData,
    switchMode,
    updateTextureData,
    updateDecalData,
    resetMode,
  };
};
